export const terms = {
  title: 'EachTeach Terms of Service',
  notice: '※The Japanese version shall be the authoritative text (the official and legally binding document). English and Korean versions are provided for reference only. In case of any discrepancy in interpretation, the Japanese version shall prevail.',
  
  article1: {
    title: 'Article 1 (Definitions)',
    intro: 'In these Terms, the following terms shall have the following meanings:',
    operator: {
      term: '"Operator":',
      definition: 'The entity that plans, manages, and operates EachTeach'
    },
    service: {
      term: '"Service":',
      definition: 'The online language exchange and learning support service provided by the Operator'
    },
    user: {
      term: '"User":',
      definition: 'Any person who uses the Service after agreeing to these Terms'
    },
    session: {
      term: '"Session":',
      definition: 'Language exchange and learning time conducted in the manner specified by the Operator (typically 90 minutes)'
    }
  },
  
  article2: {
    title: 'Article 2 (Service Content)',
    point1: 'The Service matches participants and provides online sessions based on users\' language proficiency levels, learning objectives, and other factors.',
    point2: 'Sessions are conducted based on worksheets and procedural rules provided or specified by the Operator.',
    point3: 'Except for the Word Pool feature, all functions and sessions of the Service are paid services.'
  },
  
  article3: {
    title: 'Article 3 (Eligibility)',
    point1: '※This Service is intended for educational and learning support purposes and is not intended for job placement, credential issuance, or official examination preparation.',
    point2: 'Users shall prepare a stable internet environment and online communication means at their own responsibility.',
    point3: 'If a minor uses the Service, they must obtain prior consent from their guardian and, if requested by the Operator, submit documentation confirming such consent.'
  },
  
  article4: {
    title: 'Article 4 (Registration Information and Account Management)',
    point1: 'Users shall register accurate and up-to-date information.',
    point2: 'Users shall be solely responsible for their registration information and usage environment.',
    point3: 'If false information or unauthorized use is discovered, the Operator may suspend or delete the registration without prior notice.'
  },
  
  article5: {
    title: 'Article 5 (Fees, Payment, and Cancellation)',
    point1: 'The fees, payment methods, and service formats (single session, package, monthly subscription, etc.) of the Service shall be in accordance with the guidelines separately established by the Operator.',
    point2: {
      main: 'Cancellations will only be accepted if cancellation notification reaches the Operator through the designated method before 3 days prior to the scheduled session date.',
      sub1: '"3 days prior" means until 23:59 (Japan Standard Time - JST) on the date 3 days before the scheduled session date (not including the session date itself).',
      sub2: '(Example: For a session on the 10th, cancellation is valid until 23:59 on the 6th; notifications on or after the 7th are invalid)'
    },
    point3: 'For package plans, one session will be automatically consumed at 0:00 (JST) 3 days before the scheduled date of each session.',
    point4: 'After automatic consumption, no refunds, rescheduling, or compensation will be provided for any reason, including user absence, early departure, communication issues, time zone misunderstanding, illness, or other personal circumstances.',
    point5: 'In cases where service provision becomes impossible due to circumstances beyond the Operator\'s reasonable control, such as natural disasters, legal changes, or external infrastructure failures, the matter shall be handled according to methods separately determined by the Operator.',
    point6: 'Fees for monthly plans are charged on the 25th of each month as a purchase of the following month\'s allocation (prepayment for the next month).',
    point7: 'To cancel a monthly plan, please complete the designated cancellation procedure by the 15th of the current month. If the procedure is completed by the 15th, billing will stop starting from the following month. Procedures completed on or after the 16th will take effect from the month after next.'
  },
  
  article6: {
    title: 'Article 6 (Prohibited Conduct)',
    intro: 'Users shall not engage in the following conduct:',
    item1: 'Harassment, discriminatory remarks, intimidating behavior, or abusive language',
    item2: 'Solicitation for religious, political, commercial, or other profit-making purposes',
    item3: 'Unauthorized reproduction, duplication, or redistribution of teaching materials, worksheets, or content',
    item4: 'Acts that infringe upon the rights or interests of other users, the Operator, or third parties',
    item5: 'Acts that interfere with the operation of the Service',
    item6: 'Acts that violate laws or public order and morals'
  },
  
  article7: {
    title: 'Article 7 (Intellectual Property Rights)',
    content: 'Intellectual property rights related to teaching materials, texts, designs, systems, and other content provided in connection with the Service belong to the Operator or the legitimate rights holder.'
  },
  
  article8: {
    title: 'Article 8 (Recording, AI, and Data Usage)',
    point1: 'The Operator may record, audio-record, or transcribe session content to the minimum extent necessary for quality control, trouble resolution, and service improvement purposes.',
    point2: 'The data mentioned in the preceding paragraph may be used for statistical analysis, quality evaluation, and future functional improvements in a form that does not directly identify individuals.',
    point3: 'Such data will not be provided to or disclosed to third parties except as required by law.'
  },
  
  article9: {
    title: 'Article 9 (Disclaimer)',
    point1: 'The Service provides opportunities for language learning and exchange and does not guarantee specific outcomes, improvement, credential acquisition, or similar results.',
    point2: 'The Operator shall not be liable beyond a reasonable scope for troubles arising between users or with third parties.',
    point3: 'The Operator shall not be liable for damages caused by communication failures, suspension of external services, system malfunctions, or similar issues.'
  },
  
  article10: {
    title: 'Article 10 (Service Changes, Suspension, and Termination)',
    content: 'The Operator may change, suspend, or terminate all or part of the Service without prior notice if deemed necessary.'
  },
  
  article11: {
    title: 'Article 11 (Amendment of Terms)',
    point1: 'The Operator may amend these Terms as necessary.',
    point2: 'If a user uses the Service after amendments, they shall be deemed to have agreed to such amendments.'
  },
  
  article12: {
    title: 'Article 12 (Governing Law and Jurisdiction)',
    content: 'These Terms shall be governed by Japanese law, and any disputes arising in connection with the Service shall be subject to the exclusive agreed jurisdiction of the court having jurisdiction over the location of the Operator as the court of first instance.'
  }
};
